import { render, staticRenderFns } from "./LinkObject.vue?vue&type=template&id=76df8420&scoped=true"
import script from "./LinkObject.vue?vue&type=script&lang=js"
export * from "./LinkObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76df8420",
  null
  
)

export default component.exports